const pt_br = {
    values: {
        Contracts: 'Contratos',
        Activity: 'Atividade',
        Projects: 'Projetos',
        Well: 'Poço',
        Wellbore: 'Poço',

        'Description': 'Descrição',
        'Name': 'Nome',
        'Quantity': 'Quantidade',
        'UOM': 'UDM',
        'Status': 'Status',
        'Loading...': 'Carregando...',
        'New Attribute': 'Novo Atributo',
        'Edit Attribute': 'Editar Atributo',
        'Attribute Created Successfully!': 'Atributo Criado com Successo!',
        'Attribute Edited Successfully!': 'Atributo Editado com Successo!'
    }
}

module.exports = pt_br
